// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikInput } from "src/components/Forms/TextInput";

interface Props {}

const PaypalEmail: React.FC<Props> = () => {
  return (
    <Field label="Paypal Email:" mb={26}>
      <FormikInput
        name="paypalEmail"
        size="middle"
        placeholder="e.g. joe@bloggs.com"
        borderRadius={2}
        borderColor="grey5"
      />
    </Field>
  );
};

export default PaypalEmail;
